import { Ortak } from './../../../providers/ortak';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ViewController } from 'ionic-angular/navigation/view-controller';



@Component({
  selector: 'page-cariekle',
  templateUrl: 'cariekle.html',
})
export class CarieklePage {
  cari: any = { ID: -1, Definition_: "",GrupRef:1 };
  vwCari: any = {};
  KategoriListesi = [];
  aranan = "";
  skip: number = 0;
  take: number = 50;
  constructor(public navCtrl: NavController,
     public ortak: Ortak,
      public bllOrtak: BllOrtak,
       public viewCtrl: ViewController, 
       public navParams: NavParams) {
    if (navParams.get("vwCari") != null) {
      this.vwCari = navParams.get("vwCari");
      var data = new FormData();
      data.append("cari_id", this.vwCari.ID);
      this.bllOrtak.islem(data, "CariGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.cari = Sonuc.SonucObject;
        console.log("burasi",this.cari)
      }
      )
    }
  }

  ionViewDidLoad() {
    this.KategoriGetir();
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  boslukKontrol() {
    var mesaj = "";
    if (this.cari.Definition_ == null || this.cari.Definition_ == "") {
      mesaj = mesaj + "Lütfen cari adını giriniz. <br/>";
    }
    if (this.cari.GrupRef == null || this.cari.GrupRef == "") {
      mesaj = mesaj + "Lütfen cari grubu seçiniz. <br/>";
    }
    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {
    var formData = new FormData();
    if (this.boslukKontrol()) {
      formData.append("cari_json", JSON.stringify(this.cari));
      this.bllOrtak.islem(formData, "CariEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) 
        {
          this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
          this.kapat();
        }
        

      })
    }

  }

  KategoriGetir() {

    this.bllOrtak.islemWithoutPost("CariGrupListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.KategoriListesi = sonuc.SonucObject;
    })
  }

}








// WEBPACK FOOTER //
// ./src/pages/CariIslemleri/cariekle/cariekle.ts